import firebase from "firebase/app";
import "firebase/firestore";

export class Salon {
  public id = 0;
  public companyName = "";
  public companyURL = "";
  public contact = "";
  public mail = "";
  public number = 0;
  public salonGenre = 0;
  public salon_name = "";
  public salonNameKana = "";
  public salonOwnerName = "";
  public salonURL = "";
  public status = 0;
  public telephone = "";
  public address = "";
  public approvedAt = firebase.firestore.Timestamp.fromDate(new Date());
  public balance = 0;
  public building = "";
  public businessTime = "";
  public city = "";
  public exitAt = firebase.firestore.Timestamp.fromDate(new Date());
  public postalCode = "";
  public prefecture = "";
  public qrWeb = "";
  public regularHoliday = "";
  public reserveUrl = "";
  public salonCopy = "";
  public salonId = "";
  public salonIdSystem = "";
  public salonIntroduction = "";
  public facebook = "";
  public instagram = "";
  public image_url = "";
  public image_logo_url = "";
  public isSet = 0;
  public lastLogin = firebase.firestore.Timestamp.fromDate(new Date());
  public nearest_station_1 = "";
  public nearest_station_2 = "";
  public nearest_station_3 = "";
  public twitter = "";
  public type = 0;
  public salon_id = "";
}
